var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTickRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2{fill:#1b8728}.cls-1{opacity:0}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(.301 -.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checkmark-circle-2",
    transform: "translate(-.301 .22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2136",
    d: "M0 0h88v88H0z",
    className: "cls-1",
    "data-name": "Rectangle 2136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3856",
    d: "M38.431 2a36.786 36.786 0 1 0 36.431 36.785A36.609 36.609 0 0 0 38.431 2zM54.1 29.993L37.447 52.064a3.633 3.633 0 0 1-5.756.037L22.8 40.661a3.707 3.707 0 0 1 .638-5.168 3.624 3.624 0 0 1 5.119.644l5.943 7.65L48.267 25.4a3.642 3.642 0 0 1 5.137-.7 3.725 3.725 0 0 1 .692 5.187z",
    className: "cls-2",
    "data-name": "Path 3856",
    transform: "translate(5.569 5.153)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTickRound);
export default __webpack_public_path__ + "static/media/icon-tick-round.83e95861838cc949bda5537a1652d375.svg";
export { ForwardRef as ReactComponent };